import api from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export async function startVoice({ onStatus, onEvent, clientId, topic } = {}) {
  onStatus && onStatus("connecting");
  const params = { ...(clientId ? { client_id: clientId } : {}), ...(topic ? { topic } : {}) };
  const { data } = await api.post("/api/v1/realtime/session", null, { params });
  const ephemeral = data.value;
  const model = data.model;

  const pc = new RTCPeerConnection();
  const audioEl = document.createElement("audio");
  audioEl.autoplay = true;
  // iPhone Safari (and the installed home-screen app) only plays inline, attached audio
  audioEl.playsInline = true;
  audioEl.setAttribute("playsinline", "");
  audioEl.style.display = "none";
  document.body.appendChild(audioEl);
  pc.ontrack = (e) => {
    audioEl.srcObject = e.streams[0];
  };

  const stream = await navigator.mediaDevices.getUserMedia({
    audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true },
  });
  stream.getTracks().forEach((t) => pc.addTrack(t, stream));

  const dc = pc.createDataChannel("oai-events");
  dc.onmessage = (e) => {
    try {
      onEvent && onEvent(JSON.parse(e.data));
    } catch (err) {
      // ignore non-JSON realtime frames
    }
  };
  dc.onopen = () => {
    onStatus && onStatus("live");
    // Let OCTON open the conversation once; server VAD drives every turn after.
    dc.send(JSON.stringify({ type: "response.create" }));
  };

  const offer = await pc.createOffer();
  await pc.setLocalDescription(offer);

  const res = await fetch(`https://api.openai.com/v1/realtime/calls?model=${model}`, {
    method: "POST",
    body: offer.sdp,
    headers: { Authorization: `Bearer ${ephemeral}`, "Content-Type": "application/sdp" },
  });
  if (!res.ok) { stream.getTracks().forEach((t) => t.stop()); pc.close(); audioEl.remove(); throw new Error("Live voice couldn't connect. Please try again."); }
  const answerSdp = await res.text();
  await pc.setRemoteDescription({ type: "answer", sdp: answerSdp });

  return {
    stop() {
      try { stream.getTracks().forEach((t) => t.stop()); } catch (err) { /* track already stopped */ }
      try { dc.close(); } catch (err) { /* datachannel already closed */ }
      try { pc.close(); } catch (err) { /* peer already closed */ }
      audioEl.srcObject = null;
      try { audioEl.remove(); } catch (err) { /* already removed */ }
      onStatus && onStatus("idle");
    },
  };
}
